@if (institutionId > 0) {
  <div id="submodule-contacts" class="cw-module-card">
    <!-- Header -->
    <div class="cw-flex-row">
      <!-- Modul-Titel -->
      <h2>{{ 'GENERAL.CONTACTS' | translate }}</h2>
      <!-- Toolbar -->
      <phscw-toolbar
        componentIdentifier="institutionsContacts"
        [componentConnection]="$any(this)"
        [buttonAddMenu]="allowNewInstitutionContact"
        [buttonAddMenuData]="addMenuData"
        buttonAddTooltip="{{ 'SHARED.TOOLBAR.CONTACT' | translate }}"
        [buttonDelete]="allowDeleteContacts || allowDeleteOwnContacts"
        buttonDeleteTooltip="{{ 'GENERAL.DELETECONTACTS' | translate }}"
        [buttonDeleteParameter]="{disabled: checkedContacts.length < 1 || disableDeleteButton}"
        [buttonGridFilterSubmodule]="true">
      </phscw-toolbar>
    </div>
    <!-- Grid (zeigt Kontakte der aktuellen Einrichtung) -->
    <phscw-grid
      #gridInstitutionsContacts
      [gridId]="gridId"
      [simpleGrid]="true"
      [gridData]="data"
      [gridColumns]="gridColumns"
      [gridDisplayedColumns]="gridDisplayedColumns">
    </phscw-grid>
    <!-- Funktion um weitere Einträge zu laden -->
    <phscw-grid-load-more
      [gridId]="gridId"
      [enabled]="loadMoreEnabled"
      [visible]="loadMoreVisible"
      [gridPageCounter]="gridPage">
    </phscw-grid-load-more>
  </div>
}
